import { render, staticRenderFns } from "./PaymentsSideDataWidget.vue?vue&type=template&id=740202c0&scoped=true&"
import script from "./PaymentsSideDataWidget.vue?vue&type=script&lang=js&"
export * from "./PaymentsSideDataWidget.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsSideDataWidget.vue?vue&type=style&index=0&id=740202c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740202c0",
  null
  
)

export default component.exports